import React from 'react';

const Checkbox = React.memo(({ id, label, checked, onChange }) => {
  return (
    <div className="list--input">
      <label htmlFor={id}>
        <input
          type="checkbox"
          name={id}
          id={id}
          checked={checked}
          onChange={() => onChange(id)}
        />
        <span>{label}</span>
      </label>
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
